(function () {
  "use strict";

  var config = window.HPBMiniCartConfig || {};
  var selectors = {
    drawer: "#t4s-mini_cart",
    overlay: ".t4s-close-overlay",
    drawerTrigger: "[data-mini-cart-trigger]",
    close: "[data-mini-cart-close]",
    scrollArea: "[data-t4s-scroll-me]"
  };
  var isRendering = false;
  var lastCartData = null;
  var touchStartY = 0;
  var previousBodyOverflow = "";
  var isBodyScrollLocked = false;

  function getDrawer() {
    return document.querySelector(selectors.drawer);
  }

  function getOverlay() {
    return document.querySelector(selectors.overlay);
  }

  function route(name, fallback) {
    var routes = config.routes || window.T4Sroutes || {};
    return routes[name] || fallback;
  }

  function sectionIds() {
    return config.sections || ["cart_data", "mini_cart"];
  }

  function fetchJson(url, options) {
    return fetch(url, options).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () {
          return {};
        }).then(function (json) {
          var message = json.description || json.message || response.statusText;
          throw new Error(message);
        });
      }
      return response.json();
    });
  }

  function fetchText(url, options) {
    return fetch(url, options).then(function (response) {
      if (!response.ok) throw new Error(response.statusText);
      return response.text();
    });
  }

  function appendQuery(url, query) {
    return url + (url.indexOf("?") > -1 ? "&" : "?") + query;
  }

  function cartDataUrl() {
    return appendQuery(route("root_url", "/"), "sections=cart_data&_=" + Date.now());
  }

  function sectionUrl(baseUrl, sectionId) {
    return appendQuery(baseUrl, "section_id=" + encodeURIComponent(sectionId) + "&_=" + Date.now());
  }

  function fetchMiniCartHtml() {
    var cartUrl = route("cart_url", "/cart");
    var rootUrl = route("root_url", "/");
    var options = {
      method: "GET",
      headers: {
        "Accept": "text/html",
        "X-Requested-With": "XMLHttpRequest"
      }
    };

    return fetchText(sectionUrl(cartUrl, "mini_cart"), options).catch(function () {
      return fetchText(sectionUrl(rootUrl, "mini_cart"), options);
    });
  }

  function loadSections() {
    return fetchJson(cartDataUrl(), {
      method: "GET",
      headers: {
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    }).catch(function () {
      return {};
    }).then(function (sections) {
      return fetchMiniCartHtml().then(function (html) {
        sections.mini_cart = html;
        return sections;
      }).catch(function () {
        return sections;
      });
    });
  }

  function renderWithMiniCartFallback(sections) {
    if (sections && sections.mini_cart && String(sections.mini_cart).trim()) {
      renderSections(sections);
      return Promise.resolve(sections);
    }

    sections = sections || {};
    return fetchMiniCartHtml().then(function (html) {
      sections.mini_cart = html;
      renderSections(sections);
      return sections;
    }).catch(function () {
      renderSections(sections);
      return sections;
    });
  }

  function cartRequestBody(extra) {
    return Object.assign({
      sections: sectionIds().join(","),
      sections_url: window.location.pathname || "/"
    }, extra || {});
  }

  function parseHtml(html) {
    return new DOMParser().parseFromString(html || "", "text/html");
  }

  function getMiniCartContent(html) {
    var doc = parseHtml(html);
    var newDrawer = doc.querySelector(selectors.drawer);
    var sectionWrapper = doc.querySelector("#shopify-section-mini_cart");

    return {
      drawer: newDrawer,
      html: sectionWrapper ? sectionWrapper.innerHTML : html
    };
  }

  function parseCartData(html) {
    var parts = String(html || "").split("[t4s_split1]");
    var summary = (parts[1] || "").split("[t4s_split2]");

    return {
      itemCount: parseInt(summary[0], 10) || 0,
      totalPriceText: summary[1] || "",
      hasGift: summary[2] === "1"
    };
  }

  function syncCartSummary(cartData) {
    if (!cartData) return;

    var totalPriceEl = document.getElementById("ori-total-price");
    if (totalPriceEl && cartData.totalPriceText) {
      totalPriceEl.innerHTML = cartData.totalPriceText;
    }
  }

  function setLoading(element, loading) {
    if (!element) return;
    element.classList.toggle("is--loading", loading);
    if ("disabled" in element) element.disabled = loading;

    var spinner = element.querySelector(".t4s-loading__spinner");
    if (spinner) spinner.classList.toggle("t4s-dn", !loading);
  }

  function setDrawerUpdating(updating) {
    var drawer = getDrawer();
    if (drawer) drawer.classList.toggle("is--contentUpdate", updating);
  }

  function updateCartCount(count) {
    var html = document.documentElement;
    Array.prototype.slice.call(html.classList).forEach(function (className) {
      if (/^t4s-cart-count-\d+$/.test(className)) html.classList.remove(className);
    });
    html.classList.add("t4s-cart-count-" + count);

    document.querySelectorAll("[data-cart-count]").forEach(function (element) {
      element.textContent = count > 0 ? String(count) : "0";
      element.setAttribute("data-cart-count", String(count));
      element.classList.toggle("t4s-op-0", count < 1);
    });

    document.querySelectorAll(".hpb-cart-count").forEach(function (element) {
      element.textContent = count > 0 ? String(count) : "";
      element.setAttribute("data-cart-count", String(count));
    });

    document.querySelectorAll(".cart-bubble").forEach(function (bubble) {
      bubble.classList.toggle("visually-hidden", count < 1);
      bubble.toggleAttribute("data-maintain-ratio", count <= 99);
    });

    document.querySelectorAll(".cart-bubble__text-count").forEach(function (element) {
      element.textContent = count > 99 ? "99+" : String(count);
      element.classList.toggle("hidden", count < 1);
    });
  }

  function dispatchCartUpdated(detail) {
    var event = new CustomEvent("cart:updated", {
      bubbles: true,
      detail: detail || {}
    });
    document.dispatchEvent(event);
  }

  function calculateTotalComparePrice() {
    var totalCompare = 0;
    var totalPrice = 0;
    var totalItemCount = 0;
    var symbol = config.currencySymbol || "";

    document.querySelectorAll(".t4s-mini_cart__item").forEach(function (item) {
      var comparePriceEl = item.querySelector(".ori-price") || item.querySelector(".new-price");
      var qtyInput = item.querySelector("input[data-current-qty]");
      var newPriceEl = item.querySelector(".new-price");

      if (!newPriceEl || !comparePriceEl || !qtyInput) return;

      var comparePrice = parseFloat(comparePriceEl.textContent.replace(/,/g, ".").replace(/[^\d.]/g, ""));
      var quantity = parseInt(qtyInput.getAttribute("data-current-qty"), 10);
      var newPrice = parseFloat(newPriceEl.textContent.replace(/,/g, ".").replace(/[^\d.]/g, ""));

      if (Number.isNaN(comparePrice) || Number.isNaN(quantity) || Number.isNaN(newPrice)) return;

      totalCompare += comparePrice * quantity;
      totalPrice += newPrice * quantity;
      totalItemCount += quantity;
    });

    var discountPrice = totalCompare - totalPrice;
    var totalCompareEl = document.getElementById("total-original-price");
    var discountInfoEl = document.querySelector("#t4s-mini_cart .discount");
    var discountPriceEl = document.getElementById("discount-price");
    var totalPriceEl = document.getElementById("ori-total-price");
    var subtotalLabelEl = document.getElementById("subtotal-count");

    if (totalCompareEl && totalCompare) totalCompareEl.innerHTML = symbol + totalCompare.toFixed(2);
    if (discountInfoEl) discountInfoEl.style.display = discountPrice ? "flex" : "none";
    if (discountPriceEl && discountPrice) discountPriceEl.innerHTML = symbol + discountPrice.toFixed(2);
    if (totalPriceEl && totalPrice) totalPriceEl.innerHTML = symbol + totalPrice.toFixed(2);
    if (subtotalLabelEl && totalItemCount) subtotalLabelEl.innerHTML = String(totalItemCount);
  }

  function trackTouchStart(event) {
    if (event.targetTouches.length === 1) {
      touchStartY = event.targetTouches[0].clientY;
    }
  }

  function guardScrollBounds(event) {
    var scrollArea = event.target.closest(selectors.scrollArea);
    if (!scrollArea || event.targetTouches.length !== 1) return;

    var currentY = event.targetTouches[0].clientY;
    var delta = currentY - touchStartY;
    var atTop = scrollArea.scrollTop <= 0;
    var atBottom = scrollArea.scrollHeight - scrollArea.scrollTop <= scrollArea.clientHeight;

    if ((atTop && delta > 0) || (atBottom && delta < 0)) {
      event.preventDefault();
    }
  }

  function lockScroll(lock) {
    var drawer = getDrawer();
    if (lock) {
      if (!isBodyScrollLocked) {
        previousBodyOverflow = document.body.style.overflow || "";
        document.body.style.overflow = "hidden";
        isBodyScrollLocked = true;
      }
      if (drawer) {
        drawer.addEventListener("touchstart", trackTouchStart, { passive: true });
        drawer.addEventListener("touchmove", guardScrollBounds, { passive: false });
      }
    } else {
      if (isBodyScrollLocked) {
        document.body.style.overflow = previousBodyOverflow;
        previousBodyOverflow = "";
        isBodyScrollLocked = false;
      }
      if (drawer) {
        drawer.removeEventListener("touchstart", trackTouchStart);
        drawer.removeEventListener("touchmove", guardScrollBounds);
      }
    }
  }

  function clearScrollLockClasses() {
    document.documentElement.classList.remove("t4s-lock-scroll", "is--opend-drawer");
    document.body.classList.remove("t4s-lock-scroll", "is--opend-drawer");
  }

  function open() {
    var drawer = getDrawer();
    var overlay = getOverlay();

    if (!drawer) return Promise.resolve();

    if (drawer.hasAttribute("data-mini-cart-pending") && !isRendering) {
      return refresh({ open: true });
    }

    drawer.dispatchEvent(new CustomEvent("opendDrawer", { bubbles: true }));
    drawer.setAttribute("aria-hidden", "false");
    if (overlay) overlay.classList.add("is--visible");
    document.documentElement.classList.add("is--opend-drawer");
    lockScroll(true);

    return Promise.resolve();
  }

  function close(event) {
    var drawer = getDrawer();
    var overlay = getOverlay();

    if (event) event.preventDefault();
    if (!drawer) return;
    if (drawer.getAttribute("aria-hidden") !== "false") return;

    drawer.setAttribute("aria-hidden", "true");
    if (overlay) overlay.classList.remove("is--visible");
    lockScroll(false);
    clearScrollLockClasses();

    window.setTimeout(function () {
      clearScrollLockClasses();
    }, 500);
  }

  function toggle() {
    var drawer = getDrawer();
    if (drawer && drawer.getAttribute("aria-hidden") === "false") {
      close();
      return Promise.resolve();
    }

    return open();
  }

  function renderSections(sections) {
    var drawer = getDrawer();
    if (!drawer || !sections) return;

    var wasOpen = drawer.getAttribute("aria-hidden") === "false";
    var cartData = sections.cart_data ? parseCartData(sections.cart_data) : null;
    var miniCartHtml = sections.mini_cart;

    if (cartData) {
      lastCartData = cartData;
    }

    if (miniCartHtml && String(miniCartHtml).trim()) {
      var miniCartContent = getMiniCartContent(miniCartHtml);
      var newDrawer = miniCartContent.drawer;

      if (newDrawer) {
        newDrawer.setAttribute("aria-hidden", wasOpen ? "false" : "true");
        drawer.replaceWith(newDrawer);
        drawer = newDrawer;
      } else {
        drawer.innerHTML = miniCartContent.html;
      }

      drawer.removeAttribute("data-mini-cart-pending");
    }

    if (cartData) {
      drawer.setAttribute("data-ccount", String(cartData.itemCount));
      updateCartCount(cartData.itemCount);
    }

    calculateTotalComparePrice();
    syncCartSummary(cartData);
    dispatchCartUpdated({ sections: sections, cartData: cartData });
  }

  function refresh(options) {
    var shouldOpen = options && options.open;

    isRendering = true;
    setDrawerUpdating(true);

    return loadSections().then(function (sections) {
      renderSections(sections);
      if (shouldOpen) return open();
      return sections;
    }).finally(function () {
      isRendering = false;
      setDrawerUpdating(false);
    });
  }

  function addItem(variantId, quantity, options) {
    if (!variantId) return Promise.reject(new Error("Missing variant id"));

    return fetchJson(route("cart_add_url", "/cart/add") + ".js", {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify(cartRequestBody({
        id: variantId,
        quantity: quantity || 1
      }))
    }).then(function (data) {
      var rendered = data.sections ? renderWithMiniCartFallback(data.sections) : Promise.resolve(data);
      return rendered.then(function () {
        if (options && options.open) return open().then(function () { return data; });
        return data;
      });
    });
  }

  function changeItem(lineKey, quantity) {
    if (!lineKey && lineKey !== 0) return Promise.reject(new Error("Missing cart line key"));

    setDrawerUpdating(true);

    return fetchJson(route("cart_change_url", "/cart/change") + ".js", {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify(cartRequestBody({
        id: lineKey,
        quantity: Math.max(0, parseInt(quantity, 10) || 0)
      }))
    }).then(function (data) {
      if (!data.sections) return data;
      return renderWithMiniCartFallback(data.sections).then(function () {
        return data;
      });
    }).finally(function () {
      setDrawerUpdating(false);
    });
  }

  function saveNote(drawer) {
    var textarea = drawer.querySelector("#CartSpecialInstructions");
    if (!textarea) return Promise.resolve();

    return fetchJson(route("cart_update_url", "/cart/update") + ".js", {
      method: "POST",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      },
      body: JSON.stringify({ note: textarea.value })
    });
  }

  function saveDiscount(drawer) {
    var input = drawer.querySelector("#CartDiscountcode");
    var hiddenInput = drawer.querySelector("[data-cart-discount]");
    if (input && hiddenInput) hiddenInput.value = input.value.trim();
  }

  function openTool(drawer, id) {
    closeTools(drawer);

    var panel = drawer.querySelector(".t4s-mini_cart-tool__content.is--" + id);
    if (!panel) return;

    panel.classList.add("is--opend");
    panel.classList.remove("t4s-pe-none");

    var focusTarget = panel.querySelector("[data-opend-focus]");
    if (focusTarget) window.setTimeout(function () { focusTarget.focus(); }, 150);
  }

  function closeTools(drawer) {
    drawer.querySelectorAll(".t4s-mini_cart-tool__content.is--opend").forEach(function (panel) {
      panel.classList.remove("is--opend");
      panel.classList.add("t4s-pe-none");
    });
  }

  function readRatesLang(panel) {
    var template = panel.querySelector("[data-lang-rates]");
    if (!template) return {};

    try {
      return JSON.parse(template.innerHTML);
    } catch (error) {
      return {};
    }
  }

  function renderRatesResponse(panel, html, isError) {
    var target = panel.querySelector("[data-response-rates]");
    if (!target) return;
    target.innerHTML = html;
    target.classList.toggle("is--rates-error", !!isError);
    target.classList.toggle("is--rates-success", !isError);
  }

  function estimateShipping(button) {
    var panel = button.closest(".t4s-mini_cart-tool__content");
    if (!panel) return Promise.resolve();

    var country = panel.querySelector('[name="country"]');
    var province = panel.querySelector('[name="province"]');
    var zip = panel.querySelector('[name="zip"]');
    var lang = readRatesLang(panel);

    if (!country || !country.value || !zip || !zip.value) {
      renderRatesResponse(panel, "<p>" + (lang.errors || "Enter a country and ZIP code.") + "</p>", true);
      return Promise.resolve();
    }

    var params = new URLSearchParams();
    params.set("shipping_address[country]", country.value);
    if (province && province.value) params.set("shipping_address[province]", province.value);
    params.set("shipping_address[zip]", zip.value);

    setLoading(button, true);

    return fetchJson("/cart/shipping_rates.json?" + params.toString(), {
      method: "GET",
      headers: {
        "Accept": "application/json",
        "X-Requested-With": "XMLHttpRequest"
      }
    }).then(function (data) {
      var rates = data.shipping_rates || [];
      if (!rates.length) {
        renderRatesResponse(panel, "<p>" + (lang.no_rates || "No shipping rates found.") + "</p>", true);
        return;
      }

      var list = rates.map(function (rate) {
        return "<li><span class=\"t4s-key__rate\">" + rate.name + "</span> " + rate.price + "</li>";
      }).join("");
      renderRatesResponse(panel, "<div class=\"t4s-results__rates\"><ul>" + list + "</ul></div>", false);
    }).catch(function (error) {
      renderRatesResponse(panel, "<p>" + error.message + "</p>", true);
    }).finally(function () {
      setLoading(button, false);
    });
  }

  function submitKlaviyo(drawer) {
    var emailEl = drawer.querySelector("#form_input_email");
    if (!emailEl) return Promise.resolve();

    var email = emailEl.value.trim();
    var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    var klaviyo = config.klaviyo || {};

    if (!emailPattern.test(email) || !klaviyo.endpoint || !klaviyo.listId) {
      return Promise.resolve();
    }

    return fetch(klaviyo.endpoint, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "Revision": klaviyo.revision || "2025-04-15"
      },
      body: JSON.stringify({
        data: {
          type: "subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: {
                  email: email
                }
              }
            }
          },
          relationships: {
            list: {
              data: {
                type: "list",
                id: klaviyo.listId
              }
            }
          }
        }
      })
    }).then(function () {
      var successMsg = drawer.querySelector(".success-message");
      if (successMsg) successMsg.style.display = "flex";
      emailEl.value = "";
    });
  }

  function normalizeQuantity(input, value) {
    var min = parseInt(input.getAttribute("min"), 10);
    var max = parseInt(input.getAttribute("max"), 10);
    var nextValue = parseInt(value, 10);

    if (Number.isNaN(nextValue)) nextValue = Number.isNaN(min) ? 1 : min;
    if (!Number.isNaN(min) && nextValue < min) nextValue = min;
    if (!Number.isNaN(max) && nextValue > max) nextValue = max;

    return nextValue;
  }

  function handleDocumentClick(event) {
    var drawer = getDrawer();
    var trigger = event.target.closest(selectors.drawerTrigger);

    if (trigger) {
      event.preventDefault();
      event.stopImmediatePropagation();
      open();
      return;
    }

    if (event.target.closest(selectors.overlay)) {
      close(event);
      return;
    }

    if (!drawer) return;

    var closeBtn = event.target.closest(selectors.close);
    if (closeBtn && drawer.contains(closeBtn)) {
      event.stopImmediatePropagation();
      close(event);
      return;
    }

    var qtyButton = event.target.closest("[data-quantity-selector]");
    if (qtyButton && drawer.contains(qtyButton)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      var wrapper = qtyButton.closest("[data-quantity-wrapper]");
      var input = wrapper && wrapper.querySelector("[data-quantity-value]");
      if (!input) return;

      var current = parseInt(input.value || input.getAttribute("data-current-qty"), 10) || 0;
      var next = qtyButton.hasAttribute("data-increase-qty") ? current + 1 : current - 1;
      if (next < 1 && qtyButton.hasAttribute("data-decrease-qty")) next = 0;
      next = next === 0 ? 0 : normalizeQuantity(input, next);
      input.value = next;
      changeItem(input.dataset.id, next);
      return;
    }

    var removeBtn = event.target.closest("[data-cart-remove]");
    if (removeBtn && drawer.contains(removeBtn)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      changeItem(removeBtn.dataset.id, 0);
      return;
    }

    var giftBtn = event.target.closest("[data-action-atc][data-addd-gift]");
    if (giftBtn && drawer.contains(giftBtn)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      setLoading(giftBtn, true);
      addItem(giftBtn.dataset.variantId, 1, { open: true }).finally(function () {
        setLoading(giftBtn, false);
      });
      return;
    }

    var recommendBtn = event.target.closest(".minicart-recommend-right");
    if (recommendBtn && drawer.contains(recommendBtn)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (recommendBtn.classList.contains("is--loading")) return;
      setLoading(recommendBtn, true);
      addItem(recommendBtn.dataset.variantId, 1, { open: true }).then(function () {
        var container = document.querySelector(".minicart-recommend-container");
        if (container) container.style.display = "none";
      }).finally(function () {
        setLoading(recommendBtn, false);
      });
      return;
    }

    var refreshBtn = event.target.closest(".minicart-recommend-container .refresh");
    if (refreshBtn && drawer.contains(refreshBtn)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      refreshBtn.classList.toggle("rotate");
      return;
    }

    var toolBtn = event.target.closest("[data-cart-tool_action]");
    if (toolBtn && drawer.contains(toolBtn)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      openTool(drawer, toolBtn.dataset.id);
      return;
    }

    var toolCloseBtn = event.target.closest("[data-cart-tool_close]");
    if (toolCloseBtn && drawer.contains(toolCloseBtn)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      var panel = toolCloseBtn.closest(".t4s-mini_cart-tool__content");
      if (panel && panel.classList.contains("is--note") && toolCloseBtn.classList.contains("t4s-mini_cart-tool__primary")) {
        saveNote(drawer);
      }
      if (panel && panel.classList.contains("is--discount") && toolCloseBtn.matches('[data-action="save-discountcode"]')) {
        saveDiscount(drawer);
      }
      closeTools(drawer);
      return;
    }

    var ratesBtn = event.target.closest('[data-action="estimate-shipping"]');
    if (ratesBtn && drawer.contains(ratesBtn)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      estimateShipping(ratesBtn);
      return;
    }

    var klaviyoBtn = event.target.closest(".t4s-drawer__main #button1");
    if (klaviyoBtn && drawer.contains(klaviyoBtn)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      submitKlaviyo(drawer);
    }
  }

  function handleDocumentChange(event) {
    var drawer = getDrawer();
    var input = event.target.closest("input[data-action-change]");
    if (!drawer || !input || !drawer.contains(input)) return;

    event.stopImmediatePropagation();
    var next = normalizeQuantity(input, input.value);
    input.value = next;

    if (String(next) !== String(input.getAttribute("data-current-qty"))) {
      changeItem(input.dataset.id, next);
    }
  }

  function handleKeyup(event) {
    if (event.key === "Escape" || event.keyCode === 27) close(event);
  }

  function init() {
    var drawer = getDrawer();
    if (!drawer || !drawer.hasAttribute("data-mini-cart-pending")) return;
    refresh().catch(function () {});
  }

  document.addEventListener("click", handleDocumentClick, true);
  document.addEventListener("change", handleDocumentChange, true);
  document.addEventListener("blur", function (event) {
    if (event.target && event.target.matches && event.target.matches("input[data-action-change]")) {
      handleDocumentChange(event);
    }
  }, true);
  document.addEventListener("keyup", handleKeyup);
  document.addEventListener("cart:updated", function () {
    window.setTimeout(function () {
      calculateTotalComparePrice();
      syncCartSummary(lastCartData);
    }, 50);
  });

  window.HPBMiniCart = {
    open: open,
    close: close,
    toggle: toggle,
    refresh: refresh,
    renderSections: renderSections,
    addItem: addItem,
    changeItem: changeItem
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
